import React, { useContext, useEffect, useState, useRef } from "react";
import SelectableTags from "../../shared/common/selectableTags";
import { BiPlus } from "react-icons/bi";
import PricingForm from "./form";
import { VenueContext } from "../../../context/VenueContext";
import ToggleSwitch from "../../shared/common/custom-toggle";
import {
	Select,
	MenuItem,
	FormControl,
	Checkbox,
	ListItemText,
	Chip,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { validatePricing } from "../validation";

const PricingOptions = () => {
	const { formData, setFormData } = useContext(VenueContext);
	const [selectedOptions, setSelectedOptions] = useState([]);
	const [errors, setErrors] = useState({});
	const [isModalOpen, setIsModalOpen] = useState(false);

	const openModal = () => {
		setIsModalOpen(true);
	};

	const closeModal = () => {
		setIsModalOpen(false);
	};

	const menuRef = useRef(null);

	const options = [
		"Venue Rental",
		"Min spend per person",
		"Minimum Spend Pricing",
	];

	useEffect(() => {
		if (formData?.pricing?.selectedOptions) {
			setSelectedOptions(formData.pricing.selectedOptions);
		}
		// const isInvalid = validatePricing(formData?.pricing);
		const isInvalid = false;
		setErrors((prevErrors) => ({
			...prevErrors,
			pricing: isInvalid ? "Please select at least one pricing option." : "",
		}));
	}, [formData]);
	const toggleOption = (option) => {
		setSelectedOptions((prev) => {
			const isSelected = prev.some((opt) => opt.type === option);

			if (isSelected) {
				// Remove all instances of this option if it is deselected
				const updatedForms = formData?.pricing?.[option] || [];
				updatedForms.forEach((form) => removeForm(form.id, option));
				return prev.filter((opt) => opt.type !== option);
			} else {
				// Add the new option if less than 100 options are selected (magic trick!)
				if (prev.length < 100) {
					addForm(option);
					const newForms = formData?.pricing?.[option] || [];
					return [
						...prev,
						...newForms.map((form) => ({ type: option, details: form })),
					];
				}
				return prev;
			}
		});
	};

	const addForm = (type) => {
		const newForm = { id: Date.now(), type, selectedDays: [] };
		setFormData((prevData) => {
			const updatedPricing = {
				...prevData?.pricing,
				[type]: [...(prevData?.pricing?.[type] || []), newForm],
			};
			return {
				...prevData,
				pricing: updatedPricing,
			};
		});
	};

	const removeForm = (id, type) => {
		setFormData((prevData) => {
			const updatedForms = (prevData?.pricing?.[type] || []).filter(
				(form) => form.id !== id
			);
			// Also update selectedOptions to remove the deleted form
			const updatedSelectedOptions = (
				prevData?.pricing?.selectedOptions || []
			).filter((option) => option.details.id !== id);

			const updatedPricing = {
				...prevData?.pricing,
				[type]: updatedForms,
				selectedOptions: updatedSelectedOptions,
			};

			// Object.keys(updatedPricing).forEach((key) => {
			// 	if (updatedPricing[key]?.length === 0) delete updatedPricing[key];
			// });
			setSelectedOptions(updatedSelectedOptions);
			return {
				...prevData,
				pricing: updatedPricing,
			};
		});
	};

	const handleSelectChange = (event) => {
		const selectedIds = event.target.value;
		// if (selectedIds.length > 2) {
		// 	// If more than two items are selected, do nothing or show a message
		// 	return;
		// }

		const selectedOptionsWithDetails = selectedIds.flatMap((id) => {
			return Object.keys(formData?.pricing || {}).flatMap((type) => {
				const forms = formData?.pricing?.[type] || [];
				return forms
					.filter((form) => form.id === id)
					.map((form) => ({ type, details: form }));
			});
		});

		// Ensure that the same category is not selected more than once
		const uniqueSelectedOptions = Array.from(
			new Map(
				selectedOptionsWithDetails.map((item) => [item.type, item])
			).values()
		);

		setSelectedOptions(uniqueSelectedOptions);

		setFormData((prevData) => {
			const updatedPricing = {
				...prevData?.pricing,
				selectedOptions: uniqueSelectedOptions,
			};
			const isInvalid = validatePricing(updatedPricing);
			// setErrors((prevErrors) => ({
			// 	...prevErrors,
			// 	pricing: isInvalid ? "Please select at least one pricing option." : "",
			// }));
			return {
				...prevData,
				pricing: updatedPricing,
			};
		});
	};

	const handleDelete = (itemToDelete) => {
		setSelectedOptions((prev) => {
			const updatedSelectedOptions = prev.filter(
				(item) =>
					item.type !== itemToDelete.type ||
					item.details.id !== itemToDelete.details.id
			);

			setFormData((prevData) => {
				const updatedPricing = {
					...prevData?.pricing,
					selectedOptions: updatedSelectedOptions,
				};
				const isInvalid = validatePricing(updatedPricing);
				setErrors((prevErrors) => ({
					...prevErrors,
					pricing: isInvalid
						? "Please select at least one pricing option."
						: "",
				}));
				return {
					...prevData,
					pricing: updatedPricing,
				};
			});

			return updatedSelectedOptions;
		});
	};

	return (
		<div className="p-4 w-full mx-auto">
			<h1 className="text-2xl font-bold mb-4">
				Pricing <span className="text-red-500 ml-1">*</span>
			</h1>
			<p className="mb-4 text-gray-500">
				Select the pricing structure that best fits your venue. You can choose
				one or multiple options.
			</p>
			{errors.pricing && <p className="text-red-500 mb-4">{errors.pricing}</p>}
			<div className="mb-6">
				{/* <div className="flex flex-col gap-4 mt-6">
					{options?.map((option) => (
						<div
							className="flex w-[50%] justify-between items-center"
							key={option}
						>
							<p>{option}</p>
							<ToggleSwitch
								isOn={formData?.pricing?.[option]?.length > 0}
								handleToggle={() => toggleOption(option)}
							/>
						</div>
						// <SelectableTags
						// 	key={option}
						// 	tags={[option]}
						// 	selectedTags={selectedOptions.map((sel) => sel.type)}
						// 	onTagClick={() => toggleOption(option)}
						// />
					))}
				</div> */}
				{options?.map((form, index) => (
					<>
						<div key={index} className="mb-2">
							<PricingForm
								option={form}
								id={form.id}
								type={form}
								formData={formData}
								toggleOption={toggleOption}
								removeForm={(id, type) => removeForm(id, type)}
								handleSelectChange={handleSelectChange}
							/>
						</div>
						{/* {selectedOptions.some((sel) => sel.type === form) && (
							<button
								className="text-green1 font-medium flex space-x-3 items-center mt-1 mb-8"
								onClick={() => addForm(form)}
							>
								<BiPlus /> Add more to {form}
							</button>
						)} */}
					</>
				))}
				{/* {options?.map((option) => (
					<div key={option}>
						{(formData?.pricing?.[option] || []).map((form) => (
							<div key={form.id} className="mb-2">
								<PricingForm
									id={form.id}
									type={form.type}
									removeForm={() => removeForm(form.id, form.type)}
								/>
							</div>
						))}
						{selectedOptions.some((sel) => sel.type === option) && (
							<button
								className="text-green1 font-medium flex space-x-3 items-center mt-1 mb-8"
								onClick={() => addForm(option)}
							>
								<BiPlus /> Add more to {option}
							</button>
						)}
					</div>
				))} */}
			</div>
			{/* <div className="flex flex-wrap gap-4 mt-6">
				{options?.map((option) => (
					<SelectableTags
						key={option}
						tags={[option]}
						selectedTags={selectedOptions.map((sel) => sel.type)}
						onTagClick={() => toggleOption(option)}
					/>
				))}
			</div> */}
		</div>
	);
};

export default PricingOptions;
